const serviceName = '/service/orchestration'
export default serviceName
